module.exports = __webpack_public_path__ + "static/media/webdev.b04a9f0d.png";